import { Base } from '@gate31/core/src/libs/BaseComponent';
import { ConfirmPhone } from '@gate31/feature/ConfirmPhone/ConfirmPhone';

export class ConfirmPhoneDesk extends ConfirmPhone {
    static cn = new Base.BuildCn('ConfirmPhoneDesk');

    constructor(node: HTMLElement) {
        super({ node, cn: ConfirmPhoneDesk.cn });
    }
}
